import allProjectsNavigator from '../../components/Pages/allProjectsNavigator'
import {mapState, mapMutations} from "vuex";

export const projectsNavigator = {
  components: {
    allProjectsNavigator
  },
  computed: {
    ...mapState({
      openNavigator: state => state.openProjectsNavigator
    }),
  },
  methods: {
    ...mapMutations({
      toggleOpenNavigator: 'TOGGLE_OPEN_PROJECTS_NAVIGATOR'
    })
  },
}
